export default __webpack_public_path__ + "static/media/contact.5a7627bb.png";